export * from '@fhs/routing/src/routes/rewards/birthday';
export { default } from '@fhs/routing/src/routes/rewards/birthday';
